
import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { ControladorInterfaz } from "../../../controlador";
import { Utiles } from "@/__env/pluggins/event-bus";
import entregar from "./entregar-camweb/entregar.vue";
@Component({
  name: "Componente",
  props: {},
  components: {
    entregar
  }
})
export default class Componente extends Vue {
  @Prop()
  public Controlador: ControladorInterfaz;
  public get Pedido() {
    return this.Controlador.Pedido;
  }
  public get SubModo() {
    return this.Controlador.Vista.BarraDerecha.SubModo;
  }
  public set SubModo(x: string) {
    this.Controlador.Vista.BarraDerecha.SubModo = x;
  }
  public get Modo() {
    return this.Controlador.Vista.BarraDerecha.Modo;
  }
  public set Modo(x: string) {
    this.Controlador.Vista.BarraDerecha.Modo = x;
  }
  public get ReservarEspacioDerecha() {
    return this.Controlador.Vista.BarraDerecha.Anchura.Espacio;
  }

  public Archivo: File = null;
  public SeleccionarArchivo: boolean = false;

  mounted() {
    this.Eventos.push(
      this.Controlador.Vista.BarraDerecha.onSubModo.subscribe(() => {
        if (this.SubModo == "entregar_retira_cliente") {
          this.Controlador.Vista.BarraDerecha.Anchura.Espacio = 800;
        }
      })
    );

    this.SubModo = "entregar_retira_cliente";
    this.Iniciar();
  }

  public Cargando: boolean = false;
  protected Eventos: Function[] = [];
  beforeDestroy() {
    this.Eventos.forEach(x => x());
  }

  async Iniciar() {}

  async Abrir() {
    window.open(this.Pedido.DeclaracionBienDeUso);
  }

  async AgregarArchivo(x: File) {
    this.Archivo = x;
    if (this.Archivo) {
      this.Guardar();
    }
  }

  public async Guardar() {
    if (
      await Utiles.Mensajes.SiNo(
        "Guardar declaración jurada",
        `¿Está seguro de subir el archivo?`
      )
    ) {
      let e = await this.Pedido.SubirDeclararionIIBB(this.Archivo);
      if (e) {
        this.Cerrar();
        this.$EventBus.Notificaciones.Completado("Guardado correctamente");
      } else {
        this.$EventBus.Notificaciones.Error("Error al guardar el archivo");
      }
    }
  }

  public async Eliminar() {
    if (
      await Utiles.Mensajes.SiNo(
        "Eliminar declaración jurada",
        `¿Está seguro de eliminar el archivo? Si corresponde la factura tendrá retenciones de IIBB`
      )
    ) {
      let e = await this.Pedido.EliminarDeclararionIIBB();
      if (e) {
        this.Cerrar();
        this.$EventBus.Notificaciones.Completado("Eliminado correctamente");
      } else {
        this.$EventBus.Notificaciones.Error("Error al eliminar el archivo");
      }
    }
  }

  async Cerrar() {
    this.Modo = "";
  }

  public Refresh: boolean = false;
  Refrescar() {
    this.Refresh = false;
    this.$nextTick(() => (this.Refresh = true));
  }
}
